<template>
  <b-form >
    <toggle-button class="active-toggle" :value="isEnabled"
      color="#82C7EB" :sync="true" :labels="{checked:'Enabled', unchecked:'Disabled'}"
      :width="105" :height='33' style="font-size:12pt;"
      @change="togglePackages($event.value)"/>
    <info-row class="info-main-row" :title="'Group Name'">
      <b-form-input :disabled="!isEnabled" id="group-booking-name"
      class="input-info-field" type="text" v-model="groupBookingName"
      @update="update"
      :value="groupBookingName"/>
    </info-row>
  <!--   <info-row class="info-main-row" :title="'Booking Type'">
      <b-form-select :disabled="!isEnabled" :title="'Payment Method'" :options="packageOptions" v-model="groupBookingType" class="form-control" required/>
    </info-row> -->
    <!-- <info-row class="info-main-row" :title="'Booking Price'" v-if="isEnabled">
      <currency-input v-if="isEnabled" class="input-info-field" :size="14" id="guest-booking-type" name="Booking Price" :amount.sync="groupBookingPrice" :fieldState="fieldState.amount"/>
    </info-row>  -->
  </b-form>
</template>

<script>
import InfoRow from "@/components/InfoRow";
import CurrencyInput from "@/components/widgets/CurrencyInput";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    InfoRow, CurrencyInput
  },
  props: {
    packageName: {
      type: String,
      required: false,
      default: ''
    },
    packageType: {
      type: [Number, String],
      required: false,
      default: ''
    },
    packageRate: {
      type: [Number, String],
      required: false,
      default: ''
    },
    enabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      groupBookingName: this.packageName || '',
      groupBookingType: this.packageType || '',
      groupBookingPrice: this.packageRate || '',
      isEnabled: this.enabled,
      fieldState: {
        groupBookingPrice: true
      }
    };
  },
  async created() {
    await this.getPackages()
  },
  computed: {
    ...mapState({
      packages: state => state.packages.packages
    }),
    packageOptions() {
      return this.packages.map(packageOption => {
        return {
          value: packageOption.id,
          text: packageOption.name
        }
      })
    }
  },
  methods: {
    ...mapActions(["getPackages"]),
    togglePackages(value) {
      this.isEnabled = value
      this.$emit('toggle', this.isEnabled)

      if (!this.isEnabled) {
        this.reset()
      }
    },
    reset() {
      this.groupBookingType = ''
      this.groupBookingPrice = ''
    },
    setInfo(packageInfo) {
      this.groupBookingName = packageInfo.groupBookingName
    },
    update(){
      this.$emit('update', this.groupBookingName)
    }
  }
};
</script>
